/**
 * Returns { fields: [{key, label, met}], progress: 0-100, missing: string[] }
 */
export function computeFormValidation(formData) {
  const checks = [
    { key: 'first_name', label: 'First Name', met: !!formData.first_name?.trim() },
    { key: 'last_name', label: 'Last Name', met: !!formData.last_name?.trim() },
    { key: 'gender', label: 'Gender', met: !!formData.gender },
    { key: 'event_name', label: 'Event Name', met: !!formData.event_name },
    { key: 'patient_contact_time', label: 'Patient Contact Time', met: !!formData.patient_contact_time },
    { key: 'reason_for_treatment', label: 'Reason for Treatment', met: !!formData.reason_for_treatment },
    { key: 'tag_color', label: 'Triage Tag Color', met: !!formData.tag_color },
    {
      key: 'allergies',
      label: 'Allergies (enter allergies, or check NKA / Unable to Obtain)',
      met: !!formData.allergies_nka || !!formData.allergies_unable || !!formData.allergies?.trim()
    },
    {
      key: 'medication',
      label: 'Medications (enter medications, or check None / Unable to Obtain)',
      met: !!formData.medication_none || !!formData.medication_unable || !!formData.medication?.trim()
    },
    {
      key: 'pmhx',
      label: 'Past Medical History (select condition, or check None / Unable to Obtain)',
      met: (() => {
        const pmh = formData.past_medical_history || {};
        if (pmh.none || pmh.unable_to_obtain) return true;
        if (pmh.other?.trim()) return true;
        return ['asthma', 'diabetes', 'cardiac', 'hypertension', 'copd', 'emphysema', 'psychiatric']
          .some(k => pmh[k]);
      })()
    },
    {
      key: 'vitals',
      label: 'Vital Signs (2+ complete sets, or N/A)',
      met: (() => {
        if (formData.vitals_na) return true;
        let sets = 0;
        for (let i = 1; i <= 4; i++) {
          const vs = formData[`vital_signs_${i}`];
          if (vs && vs.pulse && vs.blood_pressure && vs.respiration && vs.o2_saturation && vs.ctc) sets++;
        }
        return sets >= 2;
      })()
    },
    {
      key: 'physical_assessment',
      label: 'Physical Assessment & Findings (min 40 characters)',
      met: (formData.physical_assessment || '').trim().length >= 40
    },
    { key: 'hipaa_signature_status', label: 'HIPAA Signature Status', met: !!formData.hipaa_signature_status },
  ];

  const metCount = checks.filter(c => c.met).length;
  const progress = Math.round((metCount / checks.length) * 100);
  const missing = checks.filter(c => !c.met).map(c => c.label);

  return { fields: checks, progress, missing };
}

/**
 * OTC Medication form validation — only requires name, DOB, and signature.
 */
export function computeOtcValidation(formData) {
  const checks = [
    { key: 'first_name', label: 'First Name', met: !!formData.first_name?.trim() },
    { key: 'last_name', label: 'Last Name', met: !!formData.last_name?.trim() },
    { key: 'dob', label: 'Date of Birth', met: !!formData.dob },
    { key: 'otc_signature', label: 'OTC Signature', met: !!formData.otc_signature },
  ];

  const metCount = checks.filter(c => c.met).length;
  const progress = Math.round((metCount / checks.length) * 100);
  const missing = checks.filter(c => !c.met).map(c => c.label);

  return { fields: checks, progress, missing };
}
